export default __webpack_public_path__ + "static/7-4f1e89827a5b00106634b39e231e6ff8.jpg";